// import react packages;
import React, { useEffect, useState } from "react";
// import polaris components
import { Banner, LegacyCard as Card, Checkbox, Layout, Modal, Scrollable, BlockStack, Text } from "@shopify/polaris";
// import props
import { termProp } from "app/product/modules/generic/propTypes";
import constant from "lib/constant/constant";

const TermModal = (props) => {
  const { cms, isOpen, item, loading, onSubmit, setIsOpen, isProductDiscovery = false } = props;
  const [isEnabled, setIsEnabled] = useState(false);

  const handleCheckbox = () => {
    setIsEnabled(!isEnabled);
  };

  useEffect(() => {
    setIsEnabled(false);
  }, [isOpen]);

  return (
    <Modal
      large
      open={isOpen}
      title={cms("common.section.connect.terms.title")}
      onClose={() => setIsOpen(false)}
      primaryAction={{
        content: cms("common.section.connect.terms.button.continue"),
        onAction: () => onSubmit(),
        disabled: !isEnabled,
        loading,
      }}
      secondaryActions={[
        {
          content: cms("common.section.connect.button.cancel"),
          plain: true,
          onAction: () => setIsOpen(false),
        },
      ]}
    >
      <Modal.Section>
        <BlockStack>
          <Layout>
            <Layout.Section>
              <Banner status={constant.WARNING}>
                <p>{cms("common.section.connect.paraTag.para1", { item })}</p>
              </Banner>
            </Layout.Section>
            <Layout.Section>
              <Card sectioned>
                <Scrollable shadow className="scrollHeight">
                  {!isProductDiscovery && (
                    <>
                      <b>{`${cms("common.section.connect.boldTag.b1")} `}</b>
                      {cms("common.section.connect.paraTag.para2")}
                      <br />
                      <br />
                      {cms("common.section.connect.paraTag.para3")}
                      <b>{` ${cms("section.connect.boldTag.b1")}, `}</b>
                      {cms("common.section.connect.paraTag.para4", { item })}
                      <br />
                      <br />
                    </>
                  )}
                  {cms("common.section.connect.paraTag.para5")}
                  <b>{` ${cms("section.connect.boldTag.b1")} `}</b>
                  {cms("common.section.connect.paraTag.para6", { item })}
                  <br />
                  <br />
                  <Text variant="headingSm" as="h3">
                    {cms("common.section.connect.subHeading.sub1", { item })}
                  </Text>
                  {cms("common.section.connect.paraTag.para12", { item })}
                  <br />
                  <br />
                  <Text variant="headingSm" as="h3">
                    {cms("common.section.connect.subHeading.sub2")}
                  </Text>
                  {cms("common.section.connect.paraTag.para7")}
                  <br />
                  <br />
                  {!isProductDiscovery && (
                    <>
                      <Text variant="headingSm" as="h3">
                        {cms("common.section.connect.subHeading.sub3")}
                      </Text>
                      {cms("section.connect.paraTag.para8")}
                      <br />
                      <br />
                      <Text variant="headingSm" as="h3">
                        {cms("common.section.connect.subHeading.sub4")}
                      </Text>
                      {cms("common.section.connect.paraTag.para13")}
                      <br />
                      <br />
                    </>
                  )}
                  <b>{`${cms("common.section.connect.boldTag.b2")} ${cms("common.section.connect.boldTag.b1")} `}</b>
                  {cms("common.section.connect.paraTag.para9")}
                  <br />
                  <br />
                  {!isProductDiscovery && (
                    <>
                      {cms("common.section.connect.paraTag.para10")}
                      <b>{` ${cms("common.section.connect.boldTag.b1")}`}</b>
                      {cms("common.section.connect.paraTag.para11")}
                    </>
                  )}
                </Scrollable>
              </Card>
            </Layout.Section>
          </Layout>
          <Checkbox
            checked={isEnabled}
            label={cms("common.section.connect.terms.label.acceptTerm")}
            onChange={() => handleCheckbox()}
          />
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
};

TermModal.propTypes = termProp.type;
TermModal.defaultProps = termProp.default;

export default TermModal;
